import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';
import { DangerButton, TertiaryButton } from '@components/library/button/index';
import { findCurrentLanguageInMap } from '@components/common/language_menu/languagesMap';
import { getUgtLocaleSearchString } from '../user_generated_translations/bulk_ugt_helpers';

import "./styles/main.scss";

class CustomFieldsRow extends React.Component {
  state = {
    editMode: false,
    deleteMode: false,
    isDeleteLoading: false,
    name: this.props.customFieldKey.name,
    prioritized: !!this.props.customFieldKey.prioritized
  }

  updateKey = () => {
    const { customFieldKey, updateVisibleKeys } = this.props;
    const { name, prioritized } = this.state;
    const data = { data: { attributes: { name, prioritized: !!prioritized } } };
    $.ajax({
      type: 'PUT',
      url: `/api/v4/custom_field_keys/${customFieldKey.key}${getUgtLocaleSearchString()}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(data),
      context: this,
      success: () => {
        updateVisibleKeys(customFieldKey.key, name);
      },
      error: (xhr) => {
        const bodyText = xhr.responseJSON.errors || "Please try again.";
        if (bodyText.toLowerCase().includes("prioritiz")) {
          this.setState((prevState) => ({ prioritized: !prevState.prioritized }));
        }
        Notify.create({ type: "error", title: "Failed to update.", body: bodyText });
      }
    });
  }

  deleteKey = () => {
    const { customFieldKey, updateVisibleKeys } = this.props;
    this.setState({ isDeleteLoading: true });
    $.ajax({
      type: 'DELETE',
      url: `/api/v4/custom_field_keys/${customFieldKey.key}${getUgtLocaleSearchString()}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      context: this,
      success: () => {
        updateVisibleKeys(customFieldKey.key, null);
      },
      error: () => {
        this.setState({ isDeleteLoading: false });
        Notify.create({ type: "error", title: "Failed to delete. Please try again." });
      }
    });
  }

  togglePrioritization = () => {
    this.setState((prevState) => (
      { prioritized: !prevState.prioritized }),
    () => this.updateKey());
  }

  toggleEditMode = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
      deleteMode: !prevState.editMode ? false : prevState.deleteMode
    }));
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  getValueCopy = (uniq_values) => {
    if (uniq_values === -1) {
      return bfTranslate('View Values');
    }

    if (uniq_values === 0) {
      return '-';
    }

    return `${uniq_values} ${uniq_values > 1 ? `${bfTranslate('Values')}` : `${bfTranslate('Value')}`}`;
  }

  renameKey = () => {
    if (this.state.name && this.state.name !== this.props.customFieldKey.name) {
      this.updateKey();
      this.setState({ editMode: false });
    } else {
      Notify.create({
        title: bfTranslate('Please enter a name.'),
        type: 'error',
      });
    }
  }

  renderCustomFieldValues = () => {
    const { key } = this.props.customFieldKey;
    $.ajax({
      url: `/${BF.fx.brandfolder().slug}/bulk_management/custom_field_key/${key}/values${getUgtLocaleSearchString()}`,
      type: 'GET',
      beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success(response) {
        document.getElementsByClassName("j-serverside-page")[0].innerHTML = response;
        /* eslint-disable no-undef */
        ReactRailsUJS.unmountComponents('#manage-custom-fields');
        ReactRailsUJS.mountComponents('#manage-custom-field-values');
        /* eslint-enable no-undef */
      },
      error() {}
    });
  }

  showKey() {
    const { counted_assets, uniq_values } = this.props.customFieldKey;
    return (
      <React.Fragment>
        <div className="show-custom-fields-mode">
          <div className="custom-fields-information">
            { this.renderKey() }
            <div className="fifteen-width">
              <a id={`custom-field-values-link-${this.state.name}`} onClick={this.renderCustomFieldValues}>
                {this.getValueCopy(uniq_values)}
              </a>
            </div>
            <div className="fifteen-width">
              <p>{bfTranslate((counted_assets > 0)
                ? `${counted_assets}`
                : "-")}
              </p>
            </div>
            <div className="fifteen-width">
              <Checkbox
                checked={this.state.prioritized}
                size="md"
                toggle={this.togglePrioritization}
              />
            </div>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm edit-custom-fields"
              onClick={this.toggleEditMode}
              type="button"
            >
              {this.props.isTranslateMode ? bfTranslate('Translate') : bfTranslate('Rename')}
            </button>
            <button
              className="delete-custom-fields"
              onClick={this.toggleDeleteMode}
              onKeyUp={this.toggleDeleteMode}
              type="button"
            >
              <span className="bff-trash" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderKey() {
    const { name } = this.state;
    return (
      <div className="quarter-width">
        <a href={`/${BF.fx.brandfolder().slug}?q=custom_fields.${encodeURIComponent(name)}.moderate:(*)`}>
          <span className="custom-fields-name">
            {name}
          </span>
        </a>
      </div>
    );
  }

  renderEdit() {
    const { name } = this.props.customFieldKey;
    return (
      <div className="edit-custom-fields-mode">
        <input
          className="bf-input bf-input--primary"
          id={`${name}-input`}
          onChange={(e) => this.setState({ name: e.target.value })}
          type="text"
          value={this.state.name}
        />
        <div className="edit-buttons">
          <button
            className="button tertiary md cancel"
            onClick={this.toggleEditMode}
            type="button"
          >
            {bfTranslate('Cancel')}
          </button>
          <button
            className="button primary md"
            onClick={this.renameKey}
            type="button"
          >
            {bfTranslate('Rename Key')}
          </button>
        </div>
      </div>
    );
  }

  renderDeleteWarning() {
    const { customFieldKey: { translations } } = this.props;
    const localeKeys = Object.keys(translations);
    if (localeKeys.length <= 1) return undefined;

    const customFieldKeyNames = localeKeys
      .filter((key) => translations[key].name !== undefined)
      .map((key) => {
        const languageName = findCurrentLanguageInMap(key).language;
        return `${translations[key].name} (${languageName})`;
      });

    return (
      <p className="custom-fields-row__warning">
        <span className="bff-warning" />
        {bfTranslate("This will delete")}
        <span className="custom-fields-row__warning__key-names">
          {` ${customFieldKeyNames.join(", ")}`}
        </span>
      </p>
    );
  }

  renderDelete() {
    const { isDeleteLoading } = this.state;
    return (
      <div className="delete-custom-fields-mode">
        {this.renderKey()}
        {this.renderDeleteWarning()}
        <div className="delete-buttons">
          {!isDeleteLoading && (
            <TertiaryButton
              className="delete-key-button"
              onClick={this.toggleDeleteMode}
              size="medium"
            >
              {bfTranslate("Cancel")}
            </TertiaryButton>
          )}
          <DangerButton
            disabled={isDeleteLoading}
            isLoading={isDeleteLoading}
            loadingCopy={bfTranslate('Processing')}
            onClick={this.deleteKey}
            size="medium"
          >
            {bfTranslate('Delete Key')}
          </DangerButton>
        </div>
      </div>
    );
  }

  renderRow() {
    const { editMode, deleteMode } = this.state;
    if (editMode) { return this.renderEdit(); }
    if (deleteMode) { return this.renderDelete(); }
    return this.showKey();
  }

  render() {
    return this.renderRow();
  }
}

CustomFieldsRow.propTypes = {
  customFieldKey: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    prioritized: PropTypes.bool,
    counted_assets: PropTypes.number,
    uniq_values: PropTypes.number,
    translations: PropTypes.object,
  }).isRequired,
  isTranslateMode: PropTypes.bool.isRequired,
  updateVisibleKeys: PropTypes.func.isRequired,
};

export default CustomFieldsRow;
